export default __webpack_public_path__ + "static/media/levtours.a3a901aa.png";